import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="users--navigation"
export default class extends Controller {
  static targets = ["menue", "spinner"]

  showSpinner() {
    this.spinnerTarget.classList.remove("hidden")
    this.menueTarget.classList.add("hidden")
  }
}
